import type { IContentPage } from '~~/lib/ContentfulService';
import type { TocItem } from '~/utils/extractTocItems';
import type { PageTeaserMeta } from '~/types/PageTeaserMeta';
import { isContentPageReadingTimeEnabled } from '~/utils/contentful/isContentPageReadingTimeEnabled';

export type ContentPageMappedBindingInput = {
  page: IContentPage;
  tocItems?: TocItem[];
  readingTime?: number;
  pageTeaserMeta?: PageTeaserMeta;
};

/**
 * Props for {@link ContentPage} via {@link MappedComponent} `binding`.
 * `tocitems` when `showToc` is set on the page; `readingTime` when enabled on a
 * linked {@link heroArticleSection} (`showReadingTime`),
 * aligned with `/api/contentful` payload shape.
 */
export function buildContentPageMappedBinding({
  page,
  tocItems,
  readingTime,
  pageTeaserMeta
}: ContentPageMappedBindingInput): Record<string, unknown> {
  const binding: Record<string, unknown> = {};

  if (page.fields?.showToc && tocItems !== undefined) {
    binding.tocitems = tocItems;
  }

  if (isContentPageReadingTimeEnabled(page) && readingTime !== undefined) {
    binding.readingTime = readingTime;
  }

  if (pageTeaserMeta) {
    binding.pageTeaserMeta = pageTeaserMeta;
  }

  return binding;
}
